export const buildCameraConstraints = (preferredDeviceId?: string | null): MediaStreamConstraints => {
  const video: MediaTrackConstraints = {
    width: { ideal: 1280 },
    height: { ideal: 720 },
    frameRate: { ideal: 30 },
  }

  if (preferredDeviceId && preferredDeviceId.length > 0) {
    video.deviceId = { exact: preferredDeviceId }
  }

  return { video }
}
